export function headerFunc() {
  hederShow()
}

/**
  * ハンバーガーメニュー
  */
$('.js-hamburger').on('click', function() {
  if($('.l-hamburger__line').hasClass('is-open')) {
    $('.l-hamburger__line').removeClass('is-open');
    $('.l-drawer').removeClass('is-open');
    bodyFixedOff();
  } else {
    $('.l-hamburger__line').addClass('is-open');
    $('.l-drawer').addClass('is-open');
    bodyFixedOn();
  }

  return false;
});

$('.l-drawer__item a').on('click', function() {
  $('.l-hamburger__line').removeClass('is-open');
  $('.l-drawer').removeClass('is-open');
  bodyFixedOff();

});


function bodyFixedOn() {
  const $body = $('body');
  $body.css({
    overflow: 'hidden',
  });
}

function bodyFixedOff() {
  const $body = $('body');
  $body.css({
    overflow: 'hidden auto',
  });
}

/**
 * スクロールでヘッダー表示
 */
function hederShow() {
  $(window).on('load scroll resize', function(){
    let scroll = $(window).scrollTop();
    const fvH = $('.p-home-mv').outerHeight();
    const fvTop = $('.p-home-mv').offset().top;
    const fvBottom = fvTop + fvH;
    if(scroll >= fvBottom){
      $('.l-header-pc--top').addClass('is-show');
    }else{
      $('.l-header-pc--top').removeClass('is-show');
    }
  });
}